import * as React from "react";
import {action, observable} from "mobx";
import {observer} from "mobx-react";
import * as addrs from 'email-addresses';
import {UIState} from "data/UIState";
import {IRecipient} from "data/hr/HREmailData";

import './HRCustomRecipients.pcss';
import {handleSpacePressed} from "utils";

type RecipientItemType = {
  [key: string]: IRecipient;
};

interface Props {
  onRecipientsChange:(recipients:IRecipient[])=>void;
}

@observer
export class HRCustomRecipients extends React.Component<Props> {

  @observable recipientsMap:RecipientItemType = {};
  @observable recipientsString = "";
  @observable sortedRecipients:IRecipient[] = [];

  @action removeEmailRecipient = (recipientEmailAddress:string) => {
    delete this.recipientsMap[recipientEmailAddress];
    this.updateSortedRecipients();
    this.props.onRecipientsChange(this.sortedRecipients);
  }

  @action processRecipientsString = () => {
    // Get rid of carriage returns and multiple commas.
    let cleaned = this.recipientsString.trim();
    cleaned = cleaned.replace(new RegExp("[\r\n]", "gm"), ",");
    cleaned = cleaned.replace(new RegExp("[\r]", "gm"), ",");
    cleaned = cleaned.replace(new RegExp("[\n]", "gm"), ",");
    cleaned = cleaned.replace(new RegExp("[\t]", "gm"), " ");
    cleaned = cleaned.replace(new RegExp(",+", "gm"), ",");

    const potentialEmails = addrs.parseAddressList(cleaned);// .split(";");

    if (null == potentialEmails) {
      UIState.hrOpenAlert("Problem", "We can't parse the email list you provided. Please make sure that it is formatted properly.")
    } else {

      for (let i = 0; i < potentialEmails.length; i++) {
        const email = potentialEmails[i];
        // @ts-ignore
        this.recipientsMap[email.address] = {
          name: email.name?email.name:'',
          // @ts-ignore
          email: email.address,
        }
      }

      this.updateSortedRecipients();

      this.recipientsString = "";
      this.props.onRecipientsChange(this.sortedRecipients);
    }
  }
  @action
  updateSortedRecipients = () => {
    this.sortedRecipients = Object.values(this.recipientsMap).sort((a,b)=>{
      if (a.email < b.email) { return -1; }
      else if (b.email < a.email) { return 1;}
      else { return 0 }
    });

  }

  render() {
    return (
      <div className={"hr-custom-recipients"}>

        <div>
          <textarea
            value={this.recipientsString}
            onChange={action((e) => {
              this.recipientsString = e.target.value;
            })}
          /><br/>
          <div style={{textAlign:'right'}}>
            <button onClick={this.processRecipientsString}>Add &rarr;</button>
          </div>
        </div>

        {this.sortedRecipients.length>0 &&
          <div className={"email-table-wrapper"}>
            <table className={'email-table'}>
              <tbody>
              {this.sortedRecipients.map(r=>
                <tr key={r.email}>
                  <td>{r.email}</td>
                  <td>{r.name}</td>
                  <td><a
                    onClick={(e) => {
                      e.preventDefault();
                      this.removeEmailRecipient(r.email);
                    }}
                    onKeyDown={(e)=>{ handleSpacePressed(e,() => {
                      this.removeEmailRecipient(r.email);
                    }) }}
                  ><span className="material-symbols-outlined">delete</span></a></td>
                </tr>
              )}
              </tbody>
            </table>
          </div>
        }
      </div>
    );
  }
}